// extracted by mini-css-extract-plugin
module.exports = {"hoursTable":"az_Ccc","todayRow":"az_Dcc","timeCell":"az_Ecc","holidayLabel":"az_Fcc","holidayTime":"az_Gcc","closedText":"az_Hcc"};